/** Field names for the verify-email form. */
export const VERIFY_EMAIL_FIELDS = {
  CODE: 'code'
} as const;

/** Server-side field names returned in the verify-email 400 validation payload. */
export const VERIFY_EMAIL_SERVER_FIELDS = {
  EMAIL: 'email',
  CODE: 'code'
} as const;

/** Validation error codes returned by the verify-email API. */
export const VERIFY_EMAIL_VALIDATION_ERROR_CODES = {
  REQUIRED: 'REQUIRED',
  INVALID_EMAIL: 'INVALID_EMAIL',
  INVALID_LENGTH: 'INVALID_LENGTH',
  INVALID_CODE_FORMAT: 'INVALID_CODE_FORMAT',
  INVALID_CODE: 'INVALID_CODE',
  MAX_ATTEMPTS_REACHED: 'MAX_ATTEMPTS_REACHED'
} as const;

/** Number of alphanumeric characters in a verification code. */
export const VERIFICATION_CODE_LENGTH = 5;

/** Allowed verification-code format: five alphanumeric characters. */
export const VERIFICATION_CODE_PATTERN = /^[A-Za-z0-9]{5}$/;

/**
 * Seconds the resend button stays disabled after a code is sent. UI-only and held in
 * component state, so it resets on reload — the server's own throttle is the real limit.
 */
export const RESEND_COOLDOWN_SECONDS = 30;

/** Sentry feature tag for the email-verification flow. */
export const VERIFY_EMAIL_FEATURE_TAG = 'verify-email' as const;

/** Tracking configuration for the verify-email form. */
export const VERIFY_EMAIL_FORM_TRACKING_CONFIG = {
  eventPrefix: 'verify_email',
  eventCategory: 'verify_email',
  eventLabel: 'code'
} as const;
